
<script>
export default {
  render(h, cxt) {
    return this.$createElement(this.compPath.default, {
      ref: 'asyncComp',
      class:"async-comp",
      props: this.compProps,
      on: {
        ...this.compEvents
      }
    })
  },
  props: ['compPath', 'compProps', 'compEvents'],
  mounted() {
  },
  methods: {
    GetData() {
      return this.$refs.asyncComp.GetData()
    }
  }
}
</script>
